import { useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import parse from 'html-react-parser';
import CarouselGallery from 'sealink/react-components/carousel-gallery/carousel-gallery';
import DrawerLayout from './drawer_layout';
import SubOptionCard from './sub_option_card';

const SubOptionGroups = () => {
  const location = useLocation();
  const { option } = location.state;

  // Produce the correct data structure to feed the CarouselGallery component
  const imageProcess = (images) =>
    images.map((image) => ({
      thumbnail: image.thumbnailImgURL,
      src: image.originalImg.url,
      alt: image.url,
      originalWidth: `${image.originalImg.width}`,
      originalHeight: `${image.originalImg.height}`,
    }));

  return (
    <DrawerLayout>
      <div className="py-4">
        <h5>{option.title}</h5>
      </div>

      {option.option_groups.map((subGroup) => (
        <div className="option-group py-4 border-top" key={subGroup.title}>
          <h4 className="mb-4">{subGroup.title}</h4>
          {!isEmpty(subGroup.images) && (
            <CarouselGallery images={imageProcess(subGroup.images)} />
          )}
          <div className="my-4">
            {subGroup.description ? parse(subGroup.description) : ''}
          </div>
          {subGroup.options.map((subOption) => (
            <SubOptionCard
              key={subOption.title}
              option={option}
              subOption={subOption}
              subGroup={subGroup}
            />
          ))}
        </div>
      ))}
    </DrawerLayout>
  );
};

export default SubOptionGroups;
